import {
  Alert,
  AlertIcon,
  AlertDescription,
  CloseButton,
  useDisclosure,
  Box,
  Flex,
} from '@chakra-ui/react';

// Toggle this to show/hide the site-wide alert banner
const ALERT_CONFIG = {
  enabled: false,
  status: 'warning', // 'info' | 'warning' | 'error' | 'success'
  message: 'TimechainStats has upgraded its data systems and testing is underway. You may experience brief disruptions. Thank you for your patience.',
};

export const TcsAlert = () => {
  const { isOpen, onClose } = useDisclosure({ defaultIsOpen: true });

  if (!ALERT_CONFIG.enabled || !isOpen) return null;

  return (
    <Alert status={ALERT_CONFIG.status} mt={3}>
      <Flex direction={{ base: 'column', md: 'row' }} align={{ base: 'start', md: 'center' }}>
        <AlertIcon boxSize="24px" mb={{ base: 2 }} mr={{ md: 3 }} />
        <Box flex="1">
          <AlertDescription>{ALERT_CONFIG.message}</AlertDescription>
        </Box>
        <CloseButton position='absolute' right='8px' top='8px' onClick={onClose} aria-label="Close Alert" />
      </Flex>
    </Alert>
  );
};
